<main id="convention-maintenance" class="popup maintenance-form">
    <h2>Chat/Conventions</h2>
    <select class="select" id="convention-name" bind:value={convention_name} on:click={displaySystem}>
        {#each conventions as convention}
            <option value={convention}>{convention}</option>
        {/each}
    </select>

    <div id="chat-convention">
        <div id="convention-edit-grid">
            <h3>Convention</h3>
            <textarea class="edit-box" id="convention-edit"></textarea>
        </div>

        <div id="chat-edit-grid">
            <h3>Chat</h3>
            <textarea class="edit-box" id="chat-edit"></textarea>
        </div>
    </div>

    <div class="buttons">
        <button class="select-button" on:click={saveData}>Save</button>
        <button class="select-button" on:click={newItem}>New</button>
        <button class="select-button" on:click={close}>Close</button>
    </div>
    {#if visible}
        <div transition:fade>Convention saved</div>
    {/if}
</main>

<style>
    #convention-maintenance {
        display: none;
        width: 67vw;
    }

    #chat-convention {
        display: flex;
        flex-direction: row;
        gap: 1vw;
    }

    .edit-box {
        width: 33vw;
        height: 33vh;
        border-radius: 1vh;
    }

    #convention-edit-grid {
        display:  flex;
        flex-direction: column;
    }

    .buttons {
         margin: 0 auto;
    }
</style>


<script>
    import { elementDisplay, setText, setValue, setFocus, getValue } from './utilities'
    import { user, state } from './data-store.js'
    import { writeToUser } from './user.js';
	import { fade } from 'svelte/transition';
	let visible = false;

    let convention_name = '';
    $: new_item = createNewItem($state.new_item);
    $: conventions = getConventions($user.conventions);
    function getConventions(user_conventions) {
        let conventions = [];
        for (const [convention, value] of Object.entries(user_conventions)) {
            conventions.push(convention);
        }
        conventions.sort();
        return conventions;
    }

    function displaySystem() {
        setValue('convention-edit', $user.conventions[convention_name]);
        setValue('chat-edit', $user.chat[convention_name]);
    }

    function saveData() {
        $user.conventions[convention_name] = getValue('convention-edit');
        $user.chat[convention_name] = getValue('chat-edit');
        visible = true;
        writeToUser();
        setTimeout(function(){
            visible = false;
        }, 2000);
    }

    function newItem() {
        elementDisplay('new-item', 'block');
        setText('new-item-title', 'Convention title');
        setFocus('new-item-value');
    }

    function createNewItem(new_item) {
        if (!new_item) {
            return;
        }
        convention_name = new_item;
        if (!(new_item in $user.conventions)) {
            setValue('new-item-value', '');
            setValue('convention-edit', '');
            $user.conventions[new_item] = '';
        }
        displaySystem();
    }

    function close() {
        elementDisplay('convention-maintenance', 'none');
    }
</script>